import { rgba, cssVar } from "polished";
import { createGlobalStyle } from "styled-components";

const colorsHelper = () => {
  const defaultValue = "#fff";
  return {
    "--color-brand-100": cssVar("--color-brand-100", defaultValue),
    "--color-neutral-600": cssVar("--color-neutral-600", defaultValue),
    "--opacity-level-5": cssVar("--opacity-level-5", defaultValue),
    "--opacity-level-3": cssVar("--opacity-level-3", defaultValue),
    "--opacity-level-2": cssVar("--opacity-level-2", defaultValue),
  };
};

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  body {
    background: ${(props) => props.theme.colors.background};
    color: ${(props) => props.theme.colors.text};
    font: ${(props) => `400 16px ${props.theme["@font-family"]}`};
  }
  html,
  body {
    height: 100%;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:active,
  input:-webkit-autofill:focus {
    background-color: ${(props) => props.theme["@secondary-color"]} !important;
    color: ${(props) => props.theme["@secondary-color"]} !important;
    box-shadow: 0 0 0 1000px white inset !important;
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
  }

  .muted-background {
    background-color: ${(props) => props.theme["@muted-background"]};
  }

  .secondary-background {
    background-color: ${(props) => props.theme["@secondary-color"]};
  }

  .default-background {
    background-color: ${(props) => props.theme["@default-background"]};
  }

  .default-color {
    color: ${(props) => props.theme["@default-color"]};
  }

  .primary-color {
    color: ${(props) => props.theme["@primary-color-brand"]};
  }

  .secondary-color {
    color: ${(props) => props.theme["@secondary-color"]};
    border: 1px solid ${(props) => props.theme.colors.manatee};
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }

  //table
  .ant-table-row-level-1 {
    background-color: ${(props) => props.theme["@table-row-level-1"]};
  }
  .ant-table-pagination.ant-pagination {
    margin-bottom: 0;
  }
  .ant-table-row-expand-icon,
  .ant-table-row-expand-icon-expanded {
    border: 1px solid ${(props) => props.theme["@default-color"]} !important;
    :hover {
      color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-table-row-expand-icon:focus,
  .ant-table-row-expand-icon:hover,
  .ant-table-row-expand-icon:active {
    border: 1px solid ${(props) => props.theme["@primary-color-brand"]} !important;
  }

  //modal
  .ant-modal-title {
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
  }
  .ant-modal-footer .ant-btn + .ant-btn:not(.ant-dropdown-trigger) {
    margin-left: 22px !important;
    margin-right: 14px !important;

    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: none !important;
    height: ${(props) => props.theme["@height-button-lg"]};
    width: auto;
    :hover,
    :focus {
      color: ${(props) => props.theme["@default-color"]};
      background-color: ${(props) => props.theme["@hover-input-background-color"]};
      border: none !important;
    }
  }
  .ant-modal-footer .ant-btn {
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: 1.6px solid ${(props) => props.theme.colors.text};
    height: ${(props) => props.theme["@height-button-lg"]};
    border-radius: ${(props) => props.theme["@border-radius-base"]};
    width: auto;
    :hover,
    :focus {
      background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
      border: 1.6px solid ${(props) => props.theme["@hover-input-background-color"]} !important;
      color: ${(props) => props.theme["@default-color"]};
    }
  }

  .ant-modal-footer {
    background-color: ${(props) => props.theme["@footer-background"]};
    padding: ${(props) => props.theme["@padding-2xs"]} ${(props) => props.theme["@padding-4xs"]};
  }
  .ant-modal-wrap {
    z-index: 1070 !important;
  }

  .ant-col.ant-form-item-label > label.ant-form-item-required:hover {
    pointer-events: none !important;
  }

  //inputs
  .ant-input-affix-wrapper {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    border-radius: ${(props) => props.theme["@border-radius-base"]};
    &:hover {
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
      background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
    }
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-input-affix-wrapper > input.ant-input:hover {
    background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
  }
  .ant-input-affix-wrapper > input.ant-input {
    &:hover {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
      background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
    }
  }
  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
    border-color: ${(props) => props.theme["@primary-color-brand"]};
    background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))};
  }
  .ant-input-affix-wrapper-disabled {
    background-color: ${(props) => props.theme["@avatar-background"]} !important;
  }
  .ant-input-search-large .ant-input-search-button {
    height: 50px !important;
    cursor: pointer;
  }
  .ant-input-group:focus-within {
    border-radius: 10px;
    margin-right: -2px;
    border-right: none;
    height: 50px !important;

    .ant-input-affix-wrapper,
    .ant-btn,
    .ant-input-affix-wrapper {
      border: none !important;
    }
  }
  .ant-input-clear-icon {
    color: ${() => rgba(colorsHelper()["--color-neutral-600"], Number(colorsHelper()["--opacity-level-2"]))};
    font-size: ${(props) => props.theme["@large-font-size"]};
  }

  .ant-select-clear {
    color: ${() => rgba(colorsHelper()["--color-neutral-600"], Number(colorsHelper()["--opacity-level-2"]))};
    font-size: ${(props) => props.theme["@large-font-size"]};
    background-color: transparent;
    align-items: center;
    display: flex;
    margin-right: 10px;
      .ant-select:not(.ant-select-customize-input) .ant-select-selector {
        border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
        background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
      }
    }
  }

  ::selection {
    background: ${(props) => props.theme["@primary-color-brand"]} !important;
  }

  .ant-form-item-control-input-content > textarea {
    border-radius: ${(props) => props.theme["@border-radius-base"]};
    :focus {
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
      outline: 1.6px solid ${(props) => props.theme.colors.text} !important;
      box-shadow: none !important;
      outline-offset: 1.6px !important;
    }
  }

  //notifications
  .ant-badge-count {
    background-color: ${(props) => props.theme.colors.text} !important;
    :hover {
      background-color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
  .ant-notification-notice-with-icon .ant-notification-notice-description {
    margin-right: 20px;
  }
  .notification-class {
    background-color: ${(props) => props.theme["@default-background"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border-radius: ${(props) => props.theme["@border-radius-notification"]};
  }
  .ant-notification-notice-icon {
    margin-top: -4px;
    font-size: 30px;
  }
  .ant-notification-notice-content {
    margin-top: -5px !important;
    margin-left: -15px !important;
    font-size: ${(props) => props.theme["@medium-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
  }
  .ant-notification-notice-close {
    color: ${(props) => props.theme.colors.text};
    font-size: 14px;
    top: 8px;
    right: 11px;
  }
  .anticon.ant-notification-notice-icon-success {
    color: ${(props) => props.theme["@success-feedback-color"]};
  }
  .anticon.ant-notification-notice-icon-error {
    color: ${(props) => props.theme["@danger-color"]};
  }

  //switch
  .switch-component {
    min-width: 52px;
    max-width: 52px;
  }
  .ant-switch-checked {
    background-color: ${(props) => props.theme["@primary-color-brand"]} !important;
  }
  .ant-click-animating-node {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    outline: none !important;
    -webkit-animation: none;
    animation: none;
  }

  //cancel button in popconfirm
  .ant-btn.ant-btn-default.ant-btn-sm {
    width: 45px;
    color: ${(props) => props.theme["@default-color"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border-radius: ${(props) => props.theme["@border-radius-base"]};
    border: 1px solid ${(props) => props.theme.colors.text};
    :hover,
    :focus {
      color: ${(props) => props.theme["@default-color"]};
      background-color: ${(props) => props.theme["@hover-input-background-color"]};
      border: none;
    }
  }

  .ant-btn.ant-btn-primary {
    background: ${(props) => props.theme["@primary-color-brand"]};
    border-radius: ${(props) => props.theme["@border-radius-base"]};
  }

  //confirm button in popconfirm
  .ant-btn.ant-btn-primary.ant-btn-sm {
    width: 45px;
    color: ${(props) => props.theme["@default-color"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: none;
    :hover,
    :focus {
      color: ${(props) => props.theme["@default-color"]};
      background-color: ${(props) => props.theme["@hover-input-background-color"]};
      border: none;
    }
  }

  //search field large
  .ant-input-affix-wrapper-focused,
  .ant-input-affix-wrapper:focus {
    border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
    outline: 1.6px solid ${(props) => props.theme.colors.text} !important;
    box-shadow: none !important;
    outline-offset: 1.6px !important;
    background-color: ${(props) => props.theme["@secondary-color"]} !important;
  }

  //input date picker
  .ant-picker-focused {
    border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
    outline: 1.6px solid ${(props) => props.theme.colors.text} !important;
    box-shadow: none !important;
    outline-offset: 1.6px !important;
    background-color: ${(props) => props.theme["@secondary-color"]} !important;
  }
  .ant-picker {
    height: ${(props) => props.theme["@height-input-lg"]} !important;
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    border-radius: ${(props) => props.theme["@border-radius-base"]};
    width: 100%;
    &:hover {
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
      background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-3"]))} !important;
    }
  }
  .ant-picker-range .ant-picker-active-bar {
    background-color: ${(props) => props.theme["@primary-color-brand"]} !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
    background: ${(props) => props.theme["@primary-color-brand"]} !important;
  }
  .ant-picker-ranges .ant-picker-preset>.ant-tag-blue {
    color: ${(props) => props.theme["@primary-color-brand"]} !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner:before {
    border: 1px solid ${(props) => props.theme["@primary-color-brand"]} !important;
  }

  //title columns table
  .ant-table-thead > tr > th {
    font-weight: ${(props) => props.theme["@bold-font-weight"]} !important;
  }

  //table pagination
  .ant-pagination-item-active {
    background-color: ${(props) => props.theme["@primary-color-brand"]};
    border: 1px solid ${(props) => props.theme["@primary-color-brand"]};
    :hover {
      background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
    }
    > a {
      color: ${(props) => props.theme.colors.text};
      font-weight: ${(props) => props.theme["@bold-font-weight"]} !important;
      border-radius: ${(props) => props.theme["@round-component-border-radius"]};
      border: 1px solid ${(props) => props.theme["@primary-color-brand"]};
      text-align: center;
      :hover {
        color: ${(props) => props.theme.colors.text} !important;
        background-color: ${(props) => props.theme["@hover-input-background-color"]};
        border-radius: ${(props) => props.theme["@round-component-border-radius"]};
        outline: none;
        border: 1px solid ${(props) => props.theme["@hover-input-background-color"]};
      }
    }
  }
  .ant-pagination-item:not(.ant-pagination-item-active) {
    > a {
      :hover {
        color: ${(props) => props.theme["@primary-color-brand"]} !important;
      }
    }
  }
  .ant-pagination-next .ant-pagination-item-link,
  .ant-pagination-prev .ant-pagination-item-link {
    :hover{
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
  .ant-pagination-disabled .ant-pagination-item-link, .ant-pagination-disabled:hover .ant-pagination-item-link {
    color: ${(props) => props.theme["@disabled-button"]} !important;
  }

  //input hover
  .ant-input-affix-wrapper:hover {
    background-color: ${(props) => props.theme["@hover-input-wrapper"]} !important;
    > input,
    > input:hover {
      background-color: transparent;
    }
  }

  .ant-menu-submenu-selected:active {
    background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
    color: ${(props) => props.theme["@secondary-color"]} !important;
  }

  //submenu
  .ant-menu-item.ant-menu-item-selected.ant-menu-item-only-child {
    > span {
      font-weight: 800;
    }
  }

  .ant-menu-submenu:hover>.ant-menu-submenu-title>.ant-menu-submenu-arrow {
    color: ${(props) => props.theme["@primary-color-brand"]} !important;
  }
  .ant-menu-submenu-popup > .ant-menu {
    background-color: ${(props) => props.theme["@secondary-color"]} !important;
  }

  .ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-open.ant-menu-submenu-selected {
    background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
  }

  //input error
  .ant-input-affix-wrapper.ant-input-affix-wrapper-status-error,
  .ant-input.ant-input-status-error {
    border: 1.6px solid ${(props) => props.theme["@danger-color"]} !important;
    background-color: ${(props) => props.theme["@danger-background"]};
    :hover {
      border-color: ${(props) => props.theme["@danger-color"]};
      background-color: ${(props) => props.theme["@danger-background"]} !important;
    }
    .ant-input {
      background-color: ${(props) => props.theme["@danger-background"]};
      :hover {
        border-color: ${(props) => props.theme["@danger-color"]};
        background-color: ${(props) => props.theme["@danger-background"]} !important;
      }
    }
  }
  .ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper,
  .ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover {
    background: ${(props) => props.theme["@danger-background"]} !important;
    .ant-input {
      :hover {
        background-color: ${(props) => props.theme["@danger-background"]} !important;
      }
    }
    > input,
    > input:hover {
      background-color: ${(props) => props.theme["@danger-background"]} !important;
    }
  }

  //submenu
  .ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-open > ul > li {
    padding-left: 55px !important;
  }

  //drawer
  .ant-drawer-footer {
    padding: 10px 0;
    background-color: ${(props) => props.theme["@footer-background"]};
  }
  .ant-drawer-title {
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
  }

  //label inputs
  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional):before {
    margin-right: 0 !important;
  }

  //selects
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]};
    outline: 1.6px solid ${(props) => props.theme.colors.text};
    box-shadow: none;
    outline-offset: 1.6px;
    align-items: center;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    border-radius: ${(props) => props.theme["@border-radius-base"]};
    height: ${(props) => props.theme["@input-height"]};
    align-items: center;
    font-size: ${(props) => props.theme["@medium-font-size"]};
    :hover {
      border-color: ${(props) => props.theme["@primary-color-brand"]};
      background-color: ${(props) => props.theme["@hover-input-wrapper"]};
      border-right: 1.6px solid ${(props) => props.theme["@primary-color-brand"]};
    }
  }
  .ant-select-arrow {
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
  }
  .ant-pagination-options-size-changer.ant-select-single.ant-select-show-arrow > span {
    color: ${(props) => props.theme["@default-color"]};
    font-size: 14px;
  }
  .ant-select-item-option-content {
    font-size: ${(props) => props.theme["@medium-font-size"]} !important;
  }
  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
  }
  .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
    background-color: ${(props) => props.theme["@danger-background"]} !important;
  }

  //checkbox
  .ant-checkbox-wrapper > .ant-checkbox,
  .ant-select-tree-checkbox {
    :hover {
      > span {
        border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
        background-color: ${(props) => props.theme["@hover-input-wrapper"]};
      }
    }
    > span {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
      :hover {
        border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]};
        background-color: ${(props) => props.theme["@hover-input-wrapper"]};
      }
    }
  }
  .ant-checkbox-wrapper.ant-checkbox-wrapper-checked.ant-checkbox-wrapper-in-form-item {
    > span > span {
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
      :after {
        border-color: ${(props) => props.theme.colors.text} !important;
      }
    }
    border: none !important;
    :hover {
      border: none !important;
    }
  }
  .ant-checkbox-checked .ant-checkbox-inner,
  .ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner  {
    background-color: ${(props) => props.theme["@primary-color-brand"]};
  }

  .ant-select-tree-checkbox-checked:after {
    border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
  }

  .ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner  {
    background-color: ${(props) => props.theme["@primary-color-brand"]};
    border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
    :after {
      border-color: ${(props) => props.theme.colors.text} !important;
    }
    :hover {
      background-color: ${(props) => props.theme["@hover-input-wrapper"]} !important;
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-checkbox-wrapper > .ant-checkbox > .ant-checkbox-inner {
    border-radius: 2px;
  }
  .ant-checkbox-wrapper.ant-checkbox-wrapper-checked,
  .ant-select-tree-checkbox.ant-select-tree-checkbox-checked {
    > span > span {
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
      background-color: ${(props) => props.theme["@primary-color-brand"]} !important;
      :hover {
        background-color: ${(props) => props.theme["@hover-input-wrapper"]} !important;
        border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;

      }
      :after {
        border-color: ${(props) => props.theme.colors.text} !important;
      }
    }
    border: none !important;
    :hover {
      border: none !important;
      > span > span {
        background-color: ${(props) => props.theme["@hover-input-wrapper"]} !important;
        border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
      }
    }
  }
  .ant-checkbox-checked:after {
    border: none !important;
  }
  .ant-checkbox-wrapper.ant-checkbox-wrapper-checked.ant-checkbox-wrapper-disabled,
  .ant-checkbox-wrapper.ant-checkbox-wrapper-disabled {
    > span > span {
      border: 1.6px solid ${(props) => props.theme["@input-background-disabled"]} !important;
      background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
      :after {
        border-color: ${(props) => props.theme.colors.manatee} !important;
      }
      :hover {
        border-color: ${(props) => props.theme["@input-background-disabled"]} !important;
        background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
      }
    }
  }

  //default input
  .ant-form-item-control-input-content > input {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    border-radius: ${(props) => props.theme["@border-radius-base"]} !important;
    :focus {
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
      outline: 1.6px solid ${(props) => props.theme.colors.text} !important;
      box-shadow: none !important;
      outline-offset: 1.6px !important;
    }
    :hover {
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
      background-color: ${(props) => props.theme["@hover-input-wrapper"]};
    }
  }
  .ant-input-show-count-suffix {
    font-weight: ${(props) => props.theme["@normal-font-weight"]} !important;
  }

  //radio button
  .ant-radio:hover .ant-radio-inner {
    background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
    border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
  }

  .ant-radio-inner:hover{
    background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
  }
  .ant-radio-inner:after {
    background-color: ${(props) => props.theme.colors.text};
    :hover {
      background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-radio-checked > span {
    background-color: ${(props) => props.theme["@primary-color-brand"]} !important;
    box-shadow: none !important;
    border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;

    :hover {
      background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
    }
  }
  .ant-radio-wrapper > span:nth-child(2) {
    font-size: ${(props) => props.theme["@medium-font-size"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
  }
  .ant-radio-wrapper.ant-radio-wrapper-checked > span:nth-child(2) {
    font-size: ${(props) => props.theme["@medium-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
  }

  //tabs
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${(props) => props.theme.colors.text} !important;
    font-weight: ${(props) => props.theme["@bold-font-weight"]} !important;
    font-size: ${(props) => props.theme["@medium-font-size"]} !important;
  }
  .ant-tabs-tab .ant-tabs-tab-btn {
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
  }
  .ant-tabs-tab-btn:hover {
    color: ${(props) => props.theme["@primary-color-brand"]} !important;
  }

  //slider
  .ant-slider-handle.ant-tooltip-open {
    border-color: ${(props) => props.theme["@primary-color-brand"]};
  }

  //arrow icon
  .ant-select-disabled .ant-select-arrow {
    color: ${(props) => props.theme["@disabled-button"]};
  }

  //input number
  .ant-input-number {
    box-shadow: none;
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    :hover {
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]};
    }
  }
  .ant-input-number:focus {
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .anticon.anticon-question-circle.ant-form-item-tooltip {
    color: ${(props) => props.theme.colors.text};
  }

  .ant-menu-inline .ant-menu-item::after {
    border-right: 3px solid ${(props) => props.theme["@primary-color-brand"]};
  }

  //menu
  .ant-menu-light .ant-menu-item-active, .ant-menu-light .ant-menu-item:hover, .ant-menu-light .ant-menu-submenu-active, .ant-menu-light .ant-menu-submenu-title:hover,
  .ant-menu-light .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open {
    color: ${(props) => props.theme["@primary-color-brand"]} !important;
  }

  .ant-checkbox-checked.ant-checkbox-inner {
    background-color: ${(props) => props.theme["@primary-color-brand"]} !important;
  }

  .ant-spin {
    color: ${(props) => props.theme["@primary-color-brand"]};

    .ant-spin-dot-item {
      background-color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
  iframe#webpack-dev-server-client-overlay{display:none!important}

  .disabledBtn[disabled] {
    background-color: ${(props) => props.theme["@muted-background"]} !important;
    border: 1.6px solid ${(props) => props.theme["@muted-background"]} !important;
    :hover,
    :focus {
      background-color: ${(props) => props.theme["@muted-background"]} !important;
      border: 1.6px solid ${(props) => props.theme["@muted-background"]} !important;
    }
  }

 .ant-modal-footer .ant-btn + button.ant-btn.disabledBtn[disabled]:not(.ant-dropdown-trigger)  {
    color: ${(props) => props.theme["@disabled-button"]} !important;
  }

  .ant-alert-warning {
    background-color: ${(props) => props.theme["@color-warning-100"]};
    border: ${(props) => props.theme["@color-warning-100"]};
  }

  .ant-alert-message {
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
  }

  .ant-alert-info {
    background-color: #DEECFF;
    border: #DEECFF;
  }

  .ant-modal-footer .ant-btn.btnExcludeItem {
    color: ${(props) => props.theme["@default-background"]} !important;
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    background-color: ${(props) => props.theme["@danger-color"]};
    border: none !important;
    :hover,
    :focus {
      color: ${(props) => props.theme["@default-background"]} !important;
      background-color: ${(props) => props.theme["@danger-color-hover"]} !important;
      border: none !important;
    }
  }
`;
